import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title1: {
        id: "intro.solfaname.1.title",
    },
    title3: {
        id: "intro.solfaname.3.title",
    },
    title4: {
        id: "intro.solfaname.4.title",
    },
    description1: {
        id: "intro.flow.1.description",
    },
    description3: {
        id: "intro.flow.3.description",
    },
    description4: {
        id: "intro.solfaname.4.description",
    },
});

export default messages;
